// 系统信息
import API from '@/api/index'
import * as cookie from '@/assets/js/cookie.js'
const state = () => ({
  // 用户信息
  userInfo: {},
  // 登录状态
  hasLogin: false,
  // 鉴权token
  token: '',
  // 为兼容旧版本暂时保留
  username: '',
  name: '',
  deptList: null,
  menuPermissions:[],//菜单权限
  lastVisitRoute:'' // 直接输入登录路径 没有权限存储登录成功后跳转
})
const getters = {
  deptList: state => {
    // if (state._deptList == null || state._deptList.length == 0) {
    //   dispatch('getDeptList')
    // }
    console.log('1111111111111111', state.deptList)
    return state.deptList
  }
}

const actions = {
  getDeptList({ commit }) {
    console.log('#######getDeptList##########')
    commit('updateDeptList', [1, 2, 3])
  }
}

const mutations = {
  // 数据初始化
  init(state) {
    let token = cookie.getCookie('token')
    let username = cookie.getCookie('username')
    if (username && token && username != '' && token != '') {
      state.token = token
      state.username = username
      state.hasLogin = true
    } else {
      state.hasLogin = false
      localStorage.clear()
      sessionStorage.clear()
      cookie.setCookie('token', '')
      cookie.setCookie('username', '')
    }
  },
  // 登录
  login(state, p) {
    console.log('登录')
    state.hasLogin = true
    state.token = p.token
    state.username = p.username
    // localStorage.setItem('token', p.token)
    // localStorage.setItem('username', p.username)
  },
  // 退出登录
  logout(state, p) {
    console.log('退出登录')
    state.userInfo = {}
    state.hasLogin = false
    state.token = ''
    state.username = ''
    sessionStorage.clear()
    localStorage.clear()
    cookie.setCookie('token', '')
    cookie.setCookie('username', '')
  },
  updateUserInfo(state, p) {
    state.userInfo = p
  },
  updateToken(state, p) {
    state.token = p
  },
  updateDeptList(state, p) {
    state.deptList = p
  },
  updateMenuPermissions(state, p) {
    state.menuPermissions = p
  },
  SET_LAST_VISIT_ROUTE(state, p) {
    state.lastVisitRoute = p
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system.js